/** The active UI language, readable outside React (formatters). Set by the I18nProvider. */
export type Lang = 'en' | 'de'

let current: Lang = 'en'

export function getLang(): Lang {
  return current
}

export function setCurrentLang(l: Lang) {
  current = l
}

export const LANG_KEY = 'lang'
